export default "__VITE_ASSET__bWEGM4tX__"